import React from 'react';
import Icon from 'chameleon/ui-stack/ui/base/icon';

const APWarningBox = ({ message }) => (
  <div className="flex gap-x-4 bg-blue-100 py-4.2 px-4.6 text-gray-900 text-14">
    <Icon className="text-blue-700 flex-shrink-0" id="info_filled" />
    <div>{message}</div>
  </div>
);

export default APWarningBox;
